export default __webpack_public_path__ + "static/media/09_summary_download.d2c4d80b.png";